export default __webpack_public_path__ + "70528b6d0beeeda4dcfb949146737d34.svg";